module.exports = __webpack_public_path__ + "static/img/k2.3854e1af.png";